import { Filter } from 'components/common';
import { messages } from 'messages';
import { PropsWithChildren, useState } from 'react';

type FilterStatusProps = PropsWithChildren & { icon?: React.JSX.Element };

const STATUS_OPTION = [
  {
    label: messages.statusEnum.active,
    value: 'true'
  },
  {
    label: messages.statusEnum.inactive,
    value: 'false'
  }
];

const FilterStatus = ({ ...props }: FilterStatusProps) => {
  const [keyword, setKeyword] = useState('');

  const handleSearch = (val: string) => {
    setKeyword(val);
  };

  return (
    <Filter.CheckboxSearch
      {...props}
      count={STATUS_OPTION.length}
      options={STATUS_OPTION.filter((option) => (keyword ? option.label.includes(keyword) : true))}
      onSearch={handleSearch}
      title={messages.status}
      placeholder={messages.status}
      fetchData={() => handleSearch('')}
    />
  );
};
export default FilterStatus;
